import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { HealthStatus } from '../types';
import { HEALTH_POLL_INTERVAL } from '../constants';

export function useHealth() {
  return useQuery({
    queryKey: queryKeys.health,
    queryFn: () => apiClient.getAbsolute<HealthStatus>('/health'),
    refetchInterval: HEALTH_POLL_INTERVAL,
  });
}
